import React, { useState, useEffect } from 'react';
import DocViewer, { IDocument, DocViewerRenderers } from '@cyntler/react-doc-viewer';

import { Box } from '@mui/material';

import 'src/sections/shared/file-viewer.css';

// ----------------------------------------------------------------------

type FilePreviewProps = {
  file: File | undefined;
};

const FilePreview: React.FC<FilePreviewProps> = ({ file }) => {
  const [docs, setDocs] = useState<IDocument[]>([]);

  useEffect(() => {
    if (file) {
      const uri = URL.createObjectURL(file);
      setDocs([{ uri, fileName: file.name }]);

      return () => {
        URL.revokeObjectURL(uri);
      };
    }
  }, [file]);

  return (
    <Box sx={{ width: '50%', backgroundColor: 'pink' }}>
      <DocViewer
        documents={docs}
        pluginRenderers={DocViewerRenderers}
        prefetchMethod="GET"
        config={{
          header: {
            disableHeader: true,
            disableFileName: true,
            retainURLParams: false,
          },
        }}
        style={{
          /* React will convert numbers to px automatically */
          width: '100%',
        }}
      />
    </Box>
  );
};

export default FilePreview;
